import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Policies: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 5.2V14.2952C14 14.6851 13.7035 15 13.3377 15H2.66227C2.29663 15 2 14.6892 2 14.3057V1.69426C2 1.31872 2.29913 1 2.66814 1H9.99787L14 5.2ZM12.6667 5.9H9.33333V2.4H3.33333V13.6H12.6667V5.9ZM5.33333 4.5H7.33333V5.9H5.33333V4.5ZM5.33333 7.3H10.6667V8.7H5.33333V7.3ZM5.33333 10.1H10.6667V11.5H5.33333V10.1Z"
        fill={color}
      />
    </svg>
  );
};

export default Policies;
